import { useQuery } from '@tanstack/react-query'

import { type EnrollmentEventType } from 'types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type EnrollmentEventOptions = {
  enrollment_types: Record<EnrollmentEventType, (string | null)[]>
}

export function useGetEnrollmentEventOptions () {
  return useQuery<EnrollmentEventOptions, GrapeAPIErrorType>({
    queryKey: ['admin', 'enrollment_event_options'],
    queryFn: async () => {
      const response = await fetchWithHeaders('/api/web/admin/enrollment_event/options')
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message ?? 'Failed to fetch enrollment event options',
          errors: errorJson.errors ?? [],
        })
      }
      return await response.json()
    },
    retry: false,
  })
}
